export const ONBOARDING_ENDPOINTS = {
  /** PO autogenerate rule (shared with PO settings). */
  GET_PO_AUTOGEN_RULE: 'purchase-order-autogenerate-po/get_rule/',
  XERO_TRACKING_CATEGORY: '/integration/xero_tracking_category/',
  RESOURCES_BULK_ACCOUNTING_UPDATE: 'v1.1/resources/bulk_update/',
  BULK_ARCHIVE_ACCOUNTING_CODES: '/v1.1/accounting-code/bulk_archive/',
  COMPLETE_ONBOARDING: 'v1.1/onboarding/complete_onboarding/',
  GET_RESOURCE_CODE_LIST: 'resource_code_list/',
  GET_ACCOUNTING_CODES: 'settings_cost_codes/',
  TENANT_JOB_NUMBER_SETTINGS: 'v1.1/tenant-job-number-settings/',
  TENANT_ONBOARDING: 'v1.1/tenant-onboarding/',
  TENANT_ONBOARDING_SKIPPED: 'v1.1/tenant-onboarding-skipped/',
  TENANT_JOB_NUMBER_VALIDATE: 'v1.1/tenant-job-number-validate/',
} as const;
